import React from 'react'

export function ExplainerGraphic(props) {
  return (
    <svg viewBox='0 0 1058 299' fill='none' {...props}>
      <g>
        <rect opacity={0.05} width={298} height={296} rx={12} fill='#3B4C6A' />
        <text
          fill='#3B4C6A'
          style={{
            whiteSpace: 'pre',
          }}
          className='gotham'
          fontWeight={500}
          fontSize={24}
          letterSpacing='0em'
        >
          <tspan x={32} y={46.7}>
            {'Your GraphQL '}
          </tspan>
          <tspan x={32} y={77.7}>
            {'Client'}
          </tspan>
        </text>
        <rect
          opacity={0.05}
          x={418}
          width={285}
          height={296}
          rx={12}
          fill='#3B4C6A'
        />
        <path
          d='M541.093 62.84v-6.87h-6.981v2.513h4.195v3.084a6.333 6.333 0 01-1.779.905c-.671.234-1.41.335-2.181.335-.84 0-1.611-.168-2.283-.436a5.499 5.499 0 01-1.745-1.24 5.323 5.323 0 01-1.141-1.877c-.268-.704-.403-1.508-.403-2.346 0-.77.135-1.542.403-2.245a5.495 5.495 0 011.141-1.844c.47-.536 1.041-.938 1.678-1.273.638-.302 1.343-.436 2.081-.436.537 0 1.007.033 1.443.134.403.067.806.201 1.175.335.369.168.705.335 1.04.57.302.2.638.436.94.704l1.846-2.179c-.436-.335-.873-.67-1.309-.938a9.18 9.18 0 00-1.41-.704 10.704 10.704 0 00-1.644-.402 11.392 11.392 0 00-1.947-.168 8.783 8.783 0 00-3.423.67 8.91 8.91 0 00-2.685 1.844c-.738.77-1.309 1.675-1.745 2.715a8.742 8.742 0 00-.604 3.25c0 1.207.201 2.347.604 3.352.403 1.04.973 1.944 1.712 2.681.738.771 1.644 1.34 2.685 1.777 1.04.435 2.215.636 3.49.636.699.003 1.396-.064 2.081-.2.637-.101 1.241-.302 1.812-.537a12.042 12.042 0 001.611-.804c.503-.335.94-.637 1.343-1.006zm6.276-2.413c0-.804.1-1.542.302-2.145.201-.637.503-1.14.872-1.541a3.404 3.404 0 011.343-.906c.503-.2 1.074-.301 1.711-.301h.168v-3.017c-1.107-.033-2.014.235-2.718.805-.739.536-1.276 1.307-1.678 2.245v-2.815h-2.853V65.12h2.853v-4.692zm16.613 4.692v-7.306c0-1.676-.437-2.95-1.343-3.854-.872-.939-2.248-1.374-4.094-1.374-1.007 0-1.88.1-2.584.268-.739.2-1.444.435-2.115.77l.772 2.246a11.745 11.745 0 011.644-.536c.571-.168 1.175-.235 1.88-.235 1.007 0 1.745.235 2.282.67.504.47.772 1.14.772 1.978v.302a16.79 16.79 0 00-1.51-.37c-.537-.1-1.175-.133-1.913-.133a7.9 7.9 0 00-2.014.234c-.604.168-1.141.402-1.577.738-.437.335-.806.737-1.041 1.24-.268.503-.369 1.072-.369 1.776v.034c0 .636.101 1.173.369 1.642.235.47.537.871.94 1.206.403.302.873.537 1.41.704a5.336 5.336 0 001.678.269c.939 0 1.745-.168 2.382-.537.672-.335 1.209-.737 1.611-1.24v1.508h2.82zm-2.752-4.457c0 .369-.068.737-.235 1.039a2.419 2.419 0 01-.705.838c-.269.234-.638.402-1.04.536a4.911 4.911 0 01-1.276.167c-.671 0-1.242-.134-1.712-.469-.469-.301-.704-.77-.704-1.34v-.067c0-.637.268-1.106.772-1.475.503-.335 1.174-.503 2.081-.503.536 0 1.073.034 1.543.134.504.1.94.201 1.276.37v.77zm18.928-1.71c0-1.039-.167-1.943-.503-2.748-.336-.804-.772-1.474-1.309-2.01a5.567 5.567 0 00-1.812-1.274 5.949 5.949 0 00-2.148-.402c-.973 0-1.813.2-2.484.67-.671.435-1.241.972-1.678 1.642v-2.078h-2.852v16.121h2.852l-.033-5.664c.436.57 1.006 1.072 1.678 1.508.671.436 1.51.67 2.517.67a5.36 5.36 0 002.148-.435c.705-.269 1.309-.704 1.846-1.24a6.037 6.037 0 001.275-2.045c.336-.77.503-1.709.503-2.715zm-2.852 0c0 .604-.101 1.14-.302 1.643-.156.468-.42.893-.772 1.24-.302.368-.671.603-1.108.804-.436.201-.872.268-1.376.268-.47 0-.94-.067-1.376-.268a3.92 3.92 0 01-1.141-.804 4.372 4.372 0 01-.805-1.24 5.097 5.097 0 01-.269-1.643c0-.603.101-1.172.269-1.642a3.6 3.6 0 01.805-1.24 3.47 3.47 0 011.141-.838 3.858 3.858 0 011.376-.268c.504 0 .94.1 1.376.268.437.202.806.47 1.108.805.335.335.604.77.772 1.273.201.47.302 1.04.302 1.642zm8.592-.804c0-.938.268-1.71.771-2.245.504-.537 1.175-.805 2.014-.805.839 0 1.477.268 1.947.805.436.503.671 1.24.671 2.212v7.004h2.853v-7.876c0-1.44-.369-2.58-1.141-3.452-.772-.838-1.846-1.273-3.256-1.273-.47 0-.906.067-1.275.167-.403.134-.738.268-1.074.503-.302.2-.604.436-.839.67a8.12 8.12 0 00-.671.838v-6.67h-2.853V65.12h2.853v-6.97zm26.279 4.357l-1.847-1.877c-.704.67-1.409 1.173-2.147 1.542-.705.402-1.578.603-2.584.603a5.166 5.166 0 01-2.149-.469 5.352 5.352 0 01-1.711-1.24c-.504-.536-.873-1.173-1.141-1.877a6.375 6.375 0 01-.403-2.279c0-.805.134-1.575.403-2.28a5.477 5.477 0 011.141-1.842c.47-.503 1.04-.905 1.711-1.24.672-.302 1.377-.436 2.149-.436.939 0 1.778.168 2.517.57a7.876 7.876 0 012.08 1.474l1.846-2.145c-.369-.368-.805-.704-1.242-1.039a9.57 9.57 0 00-1.409-.804c-.537-.201-1.074-.402-1.712-.503a9.42 9.42 0 00-2.047-.2 8.78 8.78 0 00-3.423.67c-1.007.435-1.913 1.038-2.652 1.81-.772.77-1.342 1.675-1.745 2.714-.436 1.039-.638 2.112-.638 3.285 0 1.206.202 2.312.638 3.351.436 1.006 1.007 1.91 1.745 2.648a7.77 7.77 0 002.652 1.81c1.007.435 2.114.636 3.322.636.739 0 1.443-.067 2.081-.2a5.925 5.925 0 001.745-.57 9.11 9.11 0 001.477-.905c.47-.369.906-.771 1.343-1.207zm17.855-5.597c0-1.14-.202-2.245-.638-3.218-.437-1.005-1.007-1.876-1.779-2.614-.772-.737-1.712-1.307-2.786-1.709a9.974 9.974 0 00-3.524-.637h-6.108v16.39h6.108c1.276 0 2.45-.202 3.524-.637a8.655 8.655 0 002.786-1.71c.772-.737 1.342-1.608 1.779-2.614.436-1.005.638-2.111.638-3.251zm-3.021.034c0 .837-.134 1.575-.403 2.245-.302.704-.671 1.274-1.175 1.776-.47.503-1.073.872-1.778 1.14a6.662 6.662 0 01-2.35.436h-3.255V51.344h3.255c.839 0 1.645.134 2.35.403.705.301 1.308.703 1.778 1.206.504.47.873 1.073 1.175 1.776.269.67.403 1.408.403 2.213zm17.922 3.116l-8.76-11.328h-2.651v16.39h2.852V53.455l9.029 11.663h2.416V48.73h-2.886v11.328z'
          fill='#3B4C6A'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M486.205 53.1l19.331-15.517-7.887-4.559c-1.611-.904-3.423-.904-5 0l-16.177 9.352a4.628 4.628 0 00-1.813 1.776l-.134.301 5.84 6.938 5.84 1.71z'
          fill='#4568A5'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M494.573 59.497L479.605 48.07c-2.148-1.643-2.853-4.257-2.517-6.067l-.604.37a4.615 4.615 0 00-1.813 1.776l-.067.1c-.033.067-.067.1-.067.167-.369.671-.537 1.442-.537 2.246V65.33c0 1.81.906 3.385 2.484 4.29l4.329 2.48 13.76-12.602z'
          fill='#608BD8'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M506.959 60.17l-24.567 12.869 10.27 5.932c1.577.905 3.389.905 5 0l8.089-4.692 8.121-4.659c.806-.502 1.444-1.139 1.88-1.944l-.57-1.34-4.8-5.497-3.423-.67z'
          fill='#4568A5'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M515.761 67.665l.068-.134c.335-.67.503-1.408.503-2.212V49.365c0-1.474-.571-2.715-1.678-3.72-.168-.134-.369-.302-.537-.402l-13.929 9.082 6.78 5.832 4.296 3.754c1.812 1.542 2.349 3.988 1.712 6.2l.906-.502c.805-.503 1.443-1.14 1.879-1.944z'
          fill='#608BD8'
        />
        <g
          opacity={0.6}
          stroke='#608BD8'
          strokeWidth={4}
          className='slide-left'
        >
          <path d='M433 140l-8 8 8 8M421 140l-8 8 8 8M457 140l-8 8 8 8M445 140l-8 8 8 8M409 140l-8 8 8 8M397 140l-8 8 8 8M385 140l-8 8 8 8M373 140l-8 8 8 8M361 140l-8 8 8 8M349 140l-8 8 8 8' />
          <path d='M325 140l-8 8 8 8M313 140l-8 8 8 8M349 140l-8 8 8 8M337 140l-8 8 8 8M301 140l-8 8 8 8M289 140l-8 8 8 8M277 140l-8 8 8 8M265 140l-8 8 8 8M253 140l-8 8 8 8M241 140l-8 8 8 8' />
        </g>
        <g
          opacity={0.6}
          stroke='#608BD8'
          strokeWidth={4}
          className='slide-left'
        >
          <path d='M833 140l-8 8 8 8M821 140l-8 8 8 8M857 140l-8 8 8 8M845 140l-8 8 8 8M809 140l-8 8 8 8M797 140l-8 8 8 8M785 140l-8 8 8 8M773 140l-8 8 8 8M761 140l-8 8 8 8M749 140l-8 8 8 8' />
          <path d='M725 140l-8 8 8 8M713 140l-8 8 8 8M749 140l-8 8 8 8M737 140l-8 8 8 8M701 140l-8 8 8 8M689 140l-8 8 8 8M677 140l-8 8 8 8M665 140l-8 8 8 8M653 140l-8 8 8 8M641 140l-8 8 8 8' />
        </g>
        <g
          opacity={0.6}
          stroke='#FF715E'
          strokeWidth={4}
          className='slide-right'
        >
          <path d='M364 244l8-8-8-8M376 244l8-8-8-8M340 244l8-8-8-8M352 244l8-8-8-8M388 244l8-8-8-8M400 244l8-8-8-8M412 244l8-8-8-8M424 244l8-8-8-8M436 244l8-8-8-8M448 244l8-8-8-8' />
          <path d='M256 244l8-8-8-8M268 244l8-8-8-8M232 244l8-8-8-8M244 244l8-8-8-8M280 244l8-8-8-8M292 244l8-8-8-8M304 244l8-8-8-8M316 244l8-8-8-8M328 244l8-8-8-8M340 244l8-8-8-8' />
        </g>
        <g
          opacity={0.6}
          stroke='#FF715E'
          strokeWidth={4}
          className='slide-right'
        >
          <path d='M764 244l8-8-8-8M776 244l8-8-8-8M740 244l8-8-8-8M752 244l8-8-8-8M788 244l8-8-8-8M800 244l8-8-8-8M812 244l8-8-8-8M824 244l8-8-8-8M836 244l8-8-8-8M848 244l8-8-8-8' />
          <path d='M656 244l8-8-8-8M668 244l8-8-8-8M632 244l8-8-8-8M644 244l8-8-8-8M680 244l8-8-8-8M692 244l8-8-8-8M704 244l8-8-8-8M716 244l8-8-8-8M728 244l8-8-8-8M740 244l8-8-8-8' />
        </g>
        <rect
          opacity={0.05}
          x={823}
          width={235}
          height={299}
          rx={12}
          fill='#3B4C6A'
        />
        <text
          fill='#3B4C6A'
          style={{
            whiteSpace: 'pre',
          }}
          className='gotham'
          fontWeight={500}
          fontSize={24}
          letterSpacing='0em'
        >
          <tspan x={855.258} y={46.7}>
            {'Your GraphQL '}
          </tspan>
          <tspan x={922.055} y={77.7}>
            {'Backend'}
          </tspan>
        </text>
        <g filter='url(#filter0_ddddd)'>
          <rect x={847} y={112} width={187} height={163} rx={12} fill='#fff' />
        </g>
        <path
          d='M918.914 209.229l-2.226-1.285 24.806-42.965 2.226 1.286-24.806 42.964z'
          fill='#E10098'
        />
        <path
          d='M916.177 204.511h49.612v2.571h-49.612v-2.571z'
          fill='#E10098'
        />
        <path
          d='M941.975 220.283l-24.816-14.327 1.286-2.227 24.815 14.328-1.285 2.226zm21.557-37.341l-24.816-14.328 1.286-2.226 24.815 14.327-1.285 2.227z'
          fill='#E10098'
        />
        <path
          d='M918.452 182.932l-1.286-2.226 24.815-14.328 1.286 2.227-24.815 14.327z'
          fill='#E10098'
        />
        <path
          d='M963.075 209.23l-24.806-42.964 2.227-1.286 24.806 42.964-2.227 1.286zM918.146 179h2.571v28.656h-2.571V179zm43.122 0h2.571v28.656h-2.571V179z'
          fill='#E10098'
        />
        <path
          d='M941.537 219.195l-1.123-1.945 21.583-12.461 1.123 1.945-21.583 12.461z'
          fill='#E10098'
        />
        <path
          d='M967.246 208.492c-1.487 2.587-4.802 3.47-7.388 1.983-2.587-1.487-3.47-4.802-1.983-7.389 1.487-2.586 4.802-3.469 7.388-1.982a5.39 5.39 0 011.983 7.388zm-43.153-24.922c-1.487 2.586-4.802 3.469-7.389 1.982-2.586-1.487-3.469-4.801-1.982-7.388 1.487-2.587 4.801-3.47 7.388-1.983a5.418 5.418 0 011.983 7.389zm-9.356 24.922a5.417 5.417 0 011.983-7.388 5.417 5.417 0 017.388 1.982 5.419 5.419 0 01-1.982 7.389c-2.603 1.487-5.902.604-7.389-1.983zm43.153-24.922a5.418 5.418 0 011.983-7.389 5.417 5.417 0 017.388 1.983 5.417 5.417 0 01-1.982 7.388c-2.587 1.487-5.902.604-7.389-1.982zm-16.898 40.086a5.4 5.4 0 01-5.406-5.406 5.401 5.401 0 015.406-5.406 5.4 5.4 0 015.405 5.406 5.41 5.41 0 01-5.405 5.406zm0-49.844a5.401 5.401 0 01-5.406-5.406 5.4 5.4 0 015.406-5.406 5.4 5.4 0 015.405 5.406 5.4 5.4 0 01-5.405 5.406z'
          fill='#E10098'
        />
        <g className='bounce-left' filter='url(#filter1_ddddd)'>
          <path
            d='M449.779 116.394a6 6 0 015.782-4.394h215.545c3.968 0 6.843 3.783 5.781 7.606l-6.995 25.182a11.996 11.996 0 000 6.424l6.995 25.182c1.062 3.823-1.813 7.606-5.781 7.606H455.561a6 6 0 01-5.782-4.394l-8.333-30a5.998 5.998 0 010-3.212l8.333-30z'
            fill='#fff'
          />
          <text
            fill='#608BD8'
            style={{
              whiteSpace: 'pre',
            }}
            className='gotham'
            fontWeight={500}
            fontSize={24}
            letterSpacing='0em'
          >
            <tspan x={483.195} y={155.7}>
              {'Edge Cache'}
            </tspan>
          </text>
        </g>

        <g filter='url(#filter2_ddddd)'>
          <rect x={24} y={112} width={211} height={72} rx={12} fill='#fff' />
        </g>
        <text
          fill='#3B4C6A'
          style={{
            whiteSpace: 'pre',
          }}
          className='font-mono'
          fontSize={22}
          fontWeight={500}
          letterSpacing='0em'
        >
          <tspan x={119.953} y={155.516} />
        </text>
        <text
          fill='#608BD8'
          style={{
            whiteSpace: 'pre',
          }}
          className='font-mono'
          fontSize={22}
          fontWeight={500}
          letterSpacing='0em'
        >
          <tspan x={48} y={155.516}>
            {'query'}
          </tspan>
        </text>
        <text
          fill='#3B4C6A'
          style={{
            whiteSpace: 'pre',
          }}
          className='font-mono'
          fontSize={22}
          fontWeight={500}
          letterSpacing='0em'
        >
          <tspan x={134.344} y={155.516}>
            {'{...}'}
          </tspan>
        </text>
        <g filter='url(#filter3_ddddd)'>
          <rect x={24} y={200} width={250} height={72} rx={12} fill='#fff' />
        </g>
        <text
          fill='#3B4C6A'
          style={{
            whiteSpace: 'pre',
          }}
          className='font-mono'
          fontSize={22}
          fontWeight={500}
          letterSpacing='0em'
        >
          <tspan x={163.125} y={243.516} />
        </text>
        <text
          fill='#3B4C6A'
          style={{
            whiteSpace: 'pre',
          }}
          className='font-mono'
          fontSize={22}
          fontWeight={500}
          letterSpacing='0em'
        >
          <tspan x={177.516} y={243.516}>
            {'{...}'}
          </tspan>
        </text>
        <text
          fill='#FF715E'
          style={{
            whiteSpace: 'pre',
          }}
          className='font-mono'
          fontSize={22}
          fontWeight={500}
          letterSpacing='0em'
        >
          <tspan x={48} y={243.516}>
            {'mutation'}
          </tspan>
        </text>
        <g className='bounce-right' filter='url(#filter4_ddddd)'>
          <path
            d='M443.113 207.606c-1.062-3.823 1.813-7.606 5.781-7.606h215.545a6 6 0 015.782 4.394l8.333 30a5.998 5.998 0 010 3.212l-8.333 30a6 6 0 01-5.782 4.394H448.894c-3.968 0-6.843-3.783-5.781-7.606l6.995-25.182a11.996 11.996 0 000-6.424l-6.995-25.182z'
            fill='#fff'
          />
          <text
            fill='#FF715E'
            style={{
              whiteSpace: 'pre',
            }}
            className='gotham'
            fontWeight={500}
            fontSize={24}
            letterSpacing='0em'
          >
            <tspan x={475.176} y={243.7}>
              {'Smart Purging'}
            </tspan>
          </text>
        </g>
      </g>
      <defs>
        <filter
          id='filter0_ddddd'
          x={718}
          y={34}
          width={445}
          height={421}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={3.39155} />
          <feGaussianBlur stdDeviation={4.28932} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0125 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={6.38599} />
          <feGaussianBlur stdDeviation={8.0764} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.025 0' />
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={11.3915} />
          <feGaussianBlur stdDeviation={14.4069} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0375 0' />
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={21.3066} />
          <feGaussianBlur stdDeviation={26.9466} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0535 0' />
          <feBlend in2='effect3_dropShadow' result='effect4_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={51} />
          <feGaussianBlur stdDeviation={64.5} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.03 0' />
          <feBlend in2='effect4_dropShadow' result='effect5_dropShadow' />
          <feBlend in='SourceGraphic' in2='effect5_dropShadow' result='shape' />
        </filter>
        <filter
          id='filter1_ddddd'
          x={312.228}
          y={34}
          width={493.882}
          height={330}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={3.39155} />
          <feGaussianBlur stdDeviation={4.28932} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0125 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={6.38599} />
          <feGaussianBlur stdDeviation={8.0764} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.025 0' />
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={11.3915} />
          <feGaussianBlur stdDeviation={14.4069} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0375 0' />
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={21.3066} />
          <feGaussianBlur stdDeviation={26.9466} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0535 0' />
          <feBlend in2='effect3_dropShadow' result='effect4_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={51} />
          <feGaussianBlur stdDeviation={64.5} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.03 0' />
          <feBlend in2='effect4_dropShadow' result='effect5_dropShadow' />
          <feBlend in='SourceGraphic' in2='effect5_dropShadow' result='shape' />
        </filter>
        <filter
          id='filter2_ddddd'
          x={-105}
          y={34}
          width={469}
          height={330}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={3.39155} />
          <feGaussianBlur stdDeviation={4.28932} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0125 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={6.38599} />
          <feGaussianBlur stdDeviation={8.0764} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.025 0' />
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={11.3915} />
          <feGaussianBlur stdDeviation={14.4069} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0375 0' />
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={21.3066} />
          <feGaussianBlur stdDeviation={26.9466} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0535 0' />
          <feBlend in2='effect3_dropShadow' result='effect4_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={51} />
          <feGaussianBlur stdDeviation={64.5} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.03 0' />
          <feBlend in2='effect4_dropShadow' result='effect5_dropShadow' />
          <feBlend in='SourceGraphic' in2='effect5_dropShadow' result='shape' />
        </filter>
        <filter
          id='filter3_ddddd'
          x={-105}
          y={122}
          width={508}
          height={330}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={3.39155} />
          <feGaussianBlur stdDeviation={4.28932} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0125 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={6.38599} />
          <feGaussianBlur stdDeviation={8.0764} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.025 0' />
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={11.3915} />
          <feGaussianBlur stdDeviation={14.4069} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0375 0' />
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={21.3066} />
          <feGaussianBlur stdDeviation={26.9466} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0535 0' />
          <feBlend in2='effect3_dropShadow' result='effect4_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={51} />
          <feGaussianBlur stdDeviation={64.5} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.03 0' />
          <feBlend in2='effect4_dropShadow' result='effect5_dropShadow' />
          <feBlend in='SourceGraphic' in2='effect5_dropShadow' result='shape' />
        </filter>
        <filter
          id='filter4_ddddd'
          x={313.891}
          y={122}
          width={493.882}
          height={330}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={3.39155} />
          <feGaussianBlur stdDeviation={4.28932} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0125 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={6.38599} />
          <feGaussianBlur stdDeviation={8.0764} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.025 0' />
          <feBlend in2='effect1_dropShadow' result='effect2_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={11.3915} />
          <feGaussianBlur stdDeviation={14.4069} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0375 0' />
          <feBlend in2='effect2_dropShadow' result='effect3_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={21.3066} />
          <feGaussianBlur stdDeviation={26.9466} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.0535 0' />
          <feBlend in2='effect3_dropShadow' result='effect4_dropShadow' />
          <feColorMatrix
            in='SourceAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy={51} />
          <feGaussianBlur stdDeviation={64.5} />
          <feColorMatrix values='0 0 0 0 0.231373 0 0 0 0 0.298039 0 0 0 0 0.415686 0 0 0 0.03 0' />
          <feBlend in2='effect4_dropShadow' result='effect5_dropShadow' />
          <feBlend in='SourceGraphic' in2='effect5_dropShadow' result='shape' />
        </filter>
        <clipPath id='clip0'>
          <path fill='#fff' d='M0 0H1058V299H0z' />
        </clipPath>
        <clipPath id='clip1'>
          <path
            fill='#fff'
            transform='rotate(-180 169.5 79)'
            d='M0 0H106V20H0z'
          />
        </clipPath>
        <clipPath id='clip2'>
          <path
            fill='#fff'
            transform='rotate(-180 369.5 79)'
            d='M0 0H106V20H0z'
          />
        </clipPath>
        <clipPath id='clip3'>
          <path fill='#fff' transform='translate(350 226)' d='M0 0H106V20H0z' />
        </clipPath>
        <clipPath id='clip4'>
          <path fill='#fff' transform='translate(750 226)' d='M0 0H106V20H0z' />
        </clipPath>
      </defs>
    </svg>
  )
}
